import { useEffect, useLayoutEffect } from "react";
import Sidebar from "../Sidebar/Sidebar";

import { Route, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import uiActions from "../../redux/ui/action";

import DashboardHeaderActions from "../StudyDashboard/components/DashboardHeaderActions";
import StudyDashboard from "../StudyDashboard/StudyDashboard";

import ExploreMotionTopBar from "./ExploreMotionTopBar";
import LoaderPopUp from "../loader/loader";

import "./DashboardLayout.css";
import {
  isDashboardHomePath,
  isExploreMotionHomePath,
  scrollDashboardPageToTop,
} from "./dashboardNavigation";
import { clearExploreCoursesScrollState } from "../DashboardCourses/utils/exploreCoursesScrollRestore";
import { clearStudyDashboardScrollState } from "../StudyDashboard/utils/studyDashboardScrollRestore";

import DashboardCourses from "../DashboardCourses/DashboardCourses";
import DashboardBooks from "../DashboardBooks/DashboardBooks";
import Streak from "../../containers/logged_user_components/user_refer_earn/Streak";
import Transaction from "../../containers/logged_user_components/user_refer_earn/Transcation";

const DashboardLayout = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const isLoaderVisible = useSelector((state) => state.ui.loader);

  const isCoursesPage =
    location.pathname === "/dashboard/courses" ||
    location.pathname.startsWith("/dashboard/courses/");

  const isStreakPage = location.pathname === "/dashboard/streak" || location.pathname.startsWith("/dashboard/streak/");

  // Pages that hide the sidebar
  const hideSidebar = isCoursesPage || isStreakPage;

  useLayoutEffect(() => {
    if (
      !isDashboardHomePath(location.pathname) &&
      !isExploreMotionHomePath(location.pathname)
    ) {
      return;
    }
    if (isDashboardHomePath(location.pathname)) {
      clearStudyDashboardScrollState();
    } else {
      clearExploreCoursesScrollState();
    }
    scrollDashboardPageToTop();
  }, [location.pathname]);

  useEffect(() => {
    if (!isDashboardHomePath(location.pathname)) return;
    dispatch(uiActions.finishLoading());
  }, [dispatch, location.pathname]);

  useEffect(() => {
    if (
      !isDashboardHomePath(location.pathname) &&
      !isExploreMotionHomePath(location.pathname)
    ) {
      return;
    }
    scrollDashboardPageToTop();
    const frameId = window.requestAnimationFrame(scrollDashboardPageToTop);
    return () => window.cancelAnimationFrame(frameId);
  }, [location.pathname]);

  return (
    <div
      className={`dashboard-layout${
        isCoursesPage ? " dashboard-layout--courses" : ""
      }`}
    >
      {!hideSidebar ? <Sidebar /> : null}

      <div className="dashboard-main">
        {isCoursesPage ? (
          <ExploreMotionTopBar />
        ) : !isStreakPage ? (
          <div className="dashboard-top-bar">
            <DashboardHeaderActions />
          </div>
        ) : null}

        <div className="dashboard-content">
          <Route exact path="/dashboard" component={StudyDashboard} />
          <Route exact path="/dashboard/courses" component={DashboardCourses} />
          <Route
            exact
            path="/dashboard/courses/books"
            component={DashboardBooks}
          />
          <Route
            exact
            path="/dashboard/streak"
            render={() => <Streak hideHeader />}
          />
          <Route
            exact
            path="/dashboard/streak/transcation"
            render={() => <Transaction hideHeader />}
          />
        </div>
      </div>

      {isLoaderVisible ? <LoaderPopUp /> : null}
    </div>
  );
};

export default DashboardLayout;
